import React, {
  useEffect
} from 'react';
import './Navbar.css';
import {
  Link,
  useLocation
} from 'react-router-dom'
import PageRoute from '../Utils/PageRoutes'

const NavBar = ({
  loggedIn
}) => {
  console.log("Logged In: " + loggedIn);
  const {
    pathname
  } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="navbar-fixed">
      <nav className="black" role="navigation">
        <div className="nav-wrapper container">
          <Link id="logo-container" to="/admin" className="brand-logo">Xtendliving Admin</Link>
          {loggedIn ?
            <>
              <ul className="right hide-on-med-and-down white-link">
                <li><Link to={PageRoute.home}>Home</Link></li>
                <li><Link to={PageRoute.users}>Users</Link></li>
                <li><Link to={PageRoute.doctors}>Doctors</Link></li>
                <li><Link to={PageRoute.department}>Departments</Link></li>

                {/*<a className='dropdown-trigger btn' data-target='dropdown1'>Drop Me!</a>
                <ul id='dropdown1' class='dropdown-content'>
                  <li><a href="#!">one</a></li>
                  <li><a href="#!">two</a></li>
                  <li class="divider" tabindex="-1"></li>
                  <li><a href="#!">three</a></li>
                  <li><a href="#!"><i class="material-icons">view_module</i>four</a></li>
                  <li><a href="#!"><i class="material-icons">cloud</i>five</a></li>
                </ul>*/}
                <li><Link to={PageRoute.login}>Log Out</Link></li>
              </ul>

              <ul id="nav-mobile" className="sidenav white-link">
                <li><a href={PageRoute.home}>Home</a></li>
                <li><Link to={PageRoute.users}>Users</Link></li>
                <li><Link to={PageRoute.doctors}>Doctors</Link></li>
                <li><a href={PageRoute.login}>Log Out</a></li>
              </ul>
              <a href="/" data-target="nav-mobile" className="sidenav-trigger"><i className="material-icons">menu</i></a>
            </> : ''

          }
        </div>
      </nav>
    </div>


  )
}

export default NavBar;